import { render, staticRenderFns } from "./Boosting.vue?vue&type=template&id=485244d8&scoped=true&"
import script from "./Boosting.vue?vue&type=script&lang=js&"
export * from "./Boosting.vue?vue&type=script&lang=js&"
import style0 from "./Boosting.vue?vue&type=style&index=0&id=485244d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485244d8",
  null
  
)

export default component.exports